<div class="container">

    <h2>1. Acceptance of Terms</h2>
    <p>By installing or using the Asha Sathi App, you agree to these Terms & Conditions.</p>

    <h2>2. User Eligibility</h2>
    <ul>
        <li>The app is intended for authorized users only</li>
        <li>Users must provide accurate and valid information</li>
    </ul>

    <h2>3. User Account Responsibility</h2>
    <ul>
        <li>Users are responsible for maintaining login credentials</li>
        <li>Any activity under your account is your responsibility</li>
    </ul>

    <h2>4. App Usage Guidelines</h2>
    <p>Users agree NOT to:</p>
    <ul>
        <li>Misuse the application</li>
        <li>Upload false or misleading data</li>
        <li>Attempt unauthorized access</li>
        <li>Disrupt app functionality</li>
    </ul>
    <p>Violation may result in account suspension.</p>

    <h2>5. Services Offered</h2>
    <p>The app provides:</p>
    <ul>
        <li>Field data collection tools</li>
        <li>Healthcare tracking support</li>
        <li>Communication and reporting tools</li>
    </ul>

    <p>We reserve the right to:</p>
    <ul>
        <li>Modify features</li>
        <li>Add/remove services</li>
        <li>Suspend operations temporarily</li>
    </ul>

    <h2>6. Data Usage Consent</h2>
    <p>By using the app, you agree to:</p>
    <ul>
        <li>Collection and processing of your data</li>
        <li>Usage as per Privacy Policy</li>
    </ul>

    <h2>7. Intellectual Property Rights</h2>
    <p>All app content (design, logo, code) belongs to Velodynamics</p>
    <p>Unauthorized copying or reuse is strictly prohibited</p>

    <h2>8. Limitation of Liability</h2>
    <p>We are not liable for:</p>
    <ul>
        <li>Data loss due to technical issues</li>
        <li>Service interruptions</li>
        <li>Indirect damages from app usage</li>
    </ul>

    <h2>9. Termination</h2>
    <p>We reserve the right to:</p>
    <ul>
        <li>Suspend or terminate user access</li>
        <li>Remove accounts violating terms</li>
    </ul>

    <h2>10. Governing Law</h2>
    <p>This agreement is governed by:</p>
    <ul>
        <li>Laws of India</li>
        <li>Any disputes will fall under jurisdiction of local courts.</li>
    </ul>

    <h2>11. Updates to Terms</h2>
    <ul>
        <li>We may update Terms & Conditions anytime.</li>
        <li>Continued use = acceptance of updated terms.</li>
    </ul>

    <h2>12. Contact Details</h2>
    <div class="contact">
        📧 Email: <a href="mailto:{{email}}">{{email}}</a><br>
        🏢 Company: {{companyName}}
    </div>

    <hr>

    <h2>✅ FINAL DECLARATION</h2>
    <p>
        By using the Asha Sathi App, users acknowledge that they have read, understood,
        and agreed to both the Privacy Policy and Terms & Conditions.
    </p>

</div>
